var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChooseSmile = function SvgChooseSmile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FCDC7B",
    d: "M8.511 17.018a1.2 1.2 0 0 0-.294 1.671c1.235 1.762 3.525 2.911 5.774 2.911 2.247 0 4.531-1.146 5.785-2.902a1.2 1.2 0 0 0-1.953-1.395c-.798 1.118-2.351 1.897-3.832 1.897s-3.03-.778-3.809-1.888a1.2 1.2 0 0 0-1.67-.294M9.2 10.4a1.2 1.2 0 1 1 2.4 0v2.4a1.2 1.2 0 0 1-2.4 0zM17.6 9.2a1.2 1.2 0 0 0-1.2 1.2v2.4a1.2 1.2 0 0 0 2.4 0v-2.4a1.2 1.2 0 0 0-1.2-1.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCDC7B",
    fillRule: "evenodd",
    d: "M14 27.6C6.489 27.6.4 21.512.4 14 .4 6.49 6.489.4 14 .4S27.6 6.49 27.6 14c0 7.512-6.089 13.6-13.6 13.6m0-2.4c6.186 0 11.2-5.014 11.2-11.2S20.186 2.8 14 2.8 2.8 7.815 2.8 14c0 6.186 5.014 11.2 11.2 11.2",
    clipRule: "evenodd"
  })));
};
export default SvgChooseSmile;